import React from "react";
import MiniHero from "components/miniHero";

const About: React.FC = () => {
  return (
    <div>
      <MiniHero image="/images/Gallery/DSC09732-min.jpg" text="Om oss" />
      <div className="container mx-auto mt-16 px-8 lg:px-32 py-8 max-w-7xl mb-16">
        {/* About Section */}
        <div
          className="flex flex-col lg:flex-row items-center gap-12"
          style={{ fontFamily: "'IBM Plex Mono', monospace" }}
        >
          {/* Text Section */}
          <div className="lg:w-1/2">
            <p className="text-lg text-gray-600 mb-4">
              Välkomna till Lada Basteskår – en plats där träning och gemenskap
              möts. Vår vision är att träning ska vara för alla, och vi strävar
              efter att erbjuda gruppträningar som är både varierande och
              utmanande, samtidigt som de är roliga och inspirerande.
            </p>
            <p className="text-lg text-gray-600 mb-4">
              Vi erbjuder ett brett utbud av tjänster, från funktionell
              gruppträning som stärker hela kroppen, till avkopplande och
              skräddarsydd massage som hjälper dig att återhämta dig efter
              träningen.
            </p>
            <p className="text-lg text-gray-600">
              Hos oss kan du alltid förvänta dig personlig uppmärksamhet och
              engagerade coacher som hjälper dig att nå dina mål, oavsett din
              erfarenhetsnivå.
            </p>
          </div>

          {/* Image Section */}
          <div className="lg:w-1/2 flex justify-center">
            <img
              src="/images/Gallery/DSC09732-min.jpg"
              alt="Lada Basteskår"
              className="rounded-lg shadow-lg"
            />
          </div>
        </div>

        {/* About Hanna Olsson */}
        <div className="flex flex-col lg:flex-row-reverse items-center gap-12 mt-24">
          {/* Text Section */}
          <div className="lg:w-1/2">
            <h2
              className="text-3xl font-bold text-gray-800 mb-6"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            >
              Hanna Olsson
            </h2>
            <div style={{ fontFamily: "'IBM Plex Mono', monospace" }}>
              <p className="text-lg text-gray-600 mb-4">
                Hanna Olsson, en certifierad personlig tränare, har lett Lada
                Basteskår sedan 2021. Hennes passion för träning och gemenskap
                driver henne att skapa en positiv och inspirerande miljö.
              </p>
              <p className="text-lg text-gray-600 mb-4">
                Hon utbildade sig till personlig tränare på Intensive PT 2021
                och blev senare friskvårdsterapeut vid Axelsons Institut 2024.
              </p>
              <p className="text-lg text-gray-600 mb-4">
                Hannas träningsresa började inom orientering, därefter fotboll,
                men det var först 2019 som hon verkligen fann sin passion för
                CrossFit och funktionell fitness. Sedan dess har hon varit helt
                dedikerad, och delar sin energi och mångsidiga träning med sina
                kunder.
              </p>
              <p className="text-lg text-gray-600 mb-4">
                Funktionell träning handlar om att bli starkare och mer rörlig i
                det dagliga livet. Hanna inkluderar CrossFit i sina pass, med
                fokus på styrka, kondition och explosivitet för en balanserad
                och effektiv träning.
              </p>
              <p className="text-lg text-gray-600">
                Känd för sin energi och engagemang, är Hanna också passionerad
                för burpees. Förvänta dig varierade och utmanande träningspass
                på hennes pass, som passar alla nivåer.
              </p>
            </div>
          </div>

          {/* Image Section */}
          <div className="lg:w-1/2 flex justify-center">
            <img
              src="/images/Hanna/DSC09748-min.jpg"
              alt="Hanna Olsson"
              className="rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
